<template>
  <button
    @click="$emit('nuevo')"
    type="button"
    class="button-primary button-primary-lf mt-4 p-2"
    style="border: none"
  >
    <span class="cta-small m-2" style="width: 100%"> {{ text }} </span>
  </button>
</template>
<script>
export default {
  name: "add-category",
  props: {
    text: {
      default: "",
      type: String,
    },
  },
  emits: ["nuevo"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
.button-primary-lf {
  border-radius: 4px !important;
}
/*.button-primary-lf:hover {
    background: #1719da;
}*/

</style>